
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bmp-to-jpeg-converter",
      function () {
        return require("private-next-pages/bmp-to-jpeg-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bmp-to-jpeg-converter"])
      });
    }
  